import { Component, OnDestroy, OnInit } from '@angular/core';
import { SharedService } from '../../layouts/shared-service';
import { Subscription } from 'rxjs/Rx';

import { DBService } from '../../service';
import { DBAnalysisData } from '../../model/analysis-details.model';
import { StorageService } from '../../service/storage.service';
import _moment, { default as _rollupMoment } from 'moment';

import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
export const MY_FORMATS = {
  parse: {
    dateInput: 'MM/YYYY',
  },
  display: {
    dateInput: 'MM/DD/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};



@Component({
  selector: 'app-previous-analysis',
  templateUrl: './previous-analysis.component.html',
  styleUrls: ['./previous-analysis.component.scss'],
  providers: [{
    provide: DateAdapter,
    useClass: MomentDateAdapter,
    deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
  },
  { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
  ]
})



export class PreviousAnalysisComponent implements OnInit, OnDestroy {

  pageTitle = 'Previous Activities';
  previousAnalysisKeys: DBAnalysisData[] = [];
  pageLoaded = false;
  private dbAnalysisDataSubscription?: Subscription;
  startDate: string | undefined;
  endDate: string | undefined;
  maxDate = new Date();
  auditFlag = false;
  dateRangeStart?: moment.Moment | null;
  dateRangeEnd?: moment.Moment | null;
  userAttributes?: string | null;
  dataCompile: boolean = false;
  displayErrorMessage: boolean = false;
  isLoading: boolean = false;
  errorMessage: string = ''

  constructor(private _sharedService: SharedService,
    private dbService: DBService,
    private storageService: StorageService,
  ) {
    this._sharedService.emitChange(this.pageTitle);
  }

  ngOnInit(): void {
    this.userAttributes = this.storageService.get('access'); 
    if (this.userAttributes == 'QA') {
      this.pageLoaded = false;
    }
    else if (this.userAttributes == 'GA' || this.userAttributes == 'SU' || this.userAttributes == 'PI') {
      this.getPreviousData(this.userAttributes, this.startDate, this.endDate, this.auditFlag, this.dataCompile);
//       this.dbService.getAnalysis(this.userAttributes, this.startDate, this.endDate, this.auditFlag,this.dataCompile);
//       this.rdsAnalysisDataSubscription = this.dbService.rdsAnalysisData.subscribe(
//         (data: RDSAnalysisData[]) => {
//           this.previousAnalysisKeys = data;
//           this.pageLoaded = true;
//         });
    }
  
  }

   getPreviousData(userAttributes, startDate, endDate, auditFlag, dataCompile) {
    this.errorMessage = '';
    this.isLoading = true;
    this.dbAnalysisDataSubscription = this.dbService.getAnalysis(userAttributes, startDate, endDate, auditFlag, dataCompile).subscribe({
      next: (data: DBAnalysisData[]) => {
        this.isLoading = false;
        this.displayErrorMessage = false;
        this.previousAnalysisKeys = data;
        this.pageLoaded = true;
      },
      error: (err) => {
        this.isLoading = false;
        this.displayErrorMessage = true;
        console.log(err)
        switch (err.status) {
          case 400:
            this.errorMessage = "Bad Request. Please verify the input values.";
            break;
          case 401:
            this.errorMessage = "Unauthorized access. Please login again.";
            break;
          case 403:
            this.errorMessage = "Access denied. You do not have permission to perform this action.";
            break;
          case 404:
            this.errorMessage = "No data found for the given criteria.";
            break;
          case 500:
            this.errorMessage = "Server error. Please try again later.";
            break;
          case 502:
            this.errorMessage = "Bad Gateway. The server is temporarily unavailable.";
            break;
          case 503:
            this.errorMessage = "Service Unavailable. Please try again later.";
            break;
          case 504:
            this.errorMessage = "Gateway Timeout. Server took too long to respond.";
            break;
          default:
            this.errorMessage = "Unexpected error occurred. Please try again.";
        }
      }
    });
  }

  selectedDates() {
    this.isLoading = true;
    this.displayErrorMessage = false;
    this.errorMessage = '';
    this.startDate = this.dateRangeStart?.format('MM/DD/YYYY');
    this.endDate = this.dateRangeEnd?.format('MM/DD/YYYY');
    this.previousAnalysisKeys = [];
    this.getPreviousData(this.userAttributes, this.startDate, this.endDate, this.auditFlag, this.dataCompile);
  }


  clearSelectedDates() {
    this.previousAnalysisKeys = [];
    this.dateRangeEnd = null;
    this.dateRangeStart = null;
    this.startDate = 'none';
    this.endDate = 'none';
    this.getPreviousData(this.userAttributes, this.startDate, this.endDate, this.auditFlag, this.dataCompile);

  }

  ngOnDestroy() {
    if (this.dbAnalysisDataSubscription) {
      this.dbAnalysisDataSubscription.unsubscribe();
    }
  }

}
